import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SICUDGPD_EST_CRD_PAS;

export default {

  put(payload) {
    return baseApi.put(resource, payload);
  },
};
